module.exports = __webpack_public_path__ + "static/media/econia-long.c4e4e5b8.png";